import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { Nullable } from 'corgi-types';
import type { DisplayProps, HeightProps } from 'styled-system';
import { display, height } from 'styled-system';

import { transformPrismicImageUrl } from 'common/utils/cdn/prismic';

interface TrustSealsItemIconProps {
  url: string;
  alt: Nullable<string>;
}

const ICON_SIZE = 32;

const UnstyledWrapper = styled.span<DisplayProps>`
  ${display};
`;

const Wrapper = (props: ComponentProps<typeof UnstyledWrapper>) => (
  <UnstyledWrapper display="block" {...props} />
);

const UnstyledImage = styled.img<HeightProps>`
  ${height};
`;

const Image = (props: ComponentProps<typeof UnstyledImage>) => (
  <UnstyledImage height={ICON_SIZE} {...props} />
);

const TrustSealsItemIcon = ({ url, alt }: TrustSealsItemIconProps) => {
  const src = transformPrismicImageUrl(url, ICON_SIZE);

  return (
    <Wrapper>
      <Image loading="lazy" src={src} alt={alt ?? ''} />
    </Wrapper>
  );
};

export default TrustSealsItemIcon;
